import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	computed,
	effect,
	input,
	output,
	signal
} from '@angular/core';
import { DialogService } from 'lib/ui/dialog/index.js';
import { ButtonMode, IButton } from '../../../../lib/ui/buttons/index.js';
import { CardDesign, CardPieGraph } from '../../../../lib/ui/card/card.component.js';
import { CoreComponent } from '../../../../lib/ui/core/core.component.js';
import { IconType } from '../../../../lib/ui/icons/index.js';
import { TagListItem } from '../../../../lib/ui/tag/tag-list.component.js';
import { IImage } from '../../../../lib/ui/ui-models.js';

type TitleForm = {
	readonly title: string;
};

@Component({
	selector: 'lib-layout-card',
	templateUrl: './layout-card.component.html',
	styleUrls: ['./layout-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LayoutCardComponent extends CoreComponent {
	public readonly title = input.required<string>();
	public readonly subtitle = input.required<string>();
	public readonly avatar = input.required<IImage | undefined>();
	public readonly avatarName = input.required<string>();

	public readonly tags = input<readonly TagListItem[]>();
	public readonly updated = input<string>();
	public readonly isInDialog = input<boolean>(false);
	public readonly imagePriority = input<boolean>(false);
	public readonly enableCard = input<boolean>(true);
	public readonly pieGraph = input<CardPieGraph>();
	public readonly buttons = input<readonly IButton[]>();
	public readonly buttonsMode = input<ButtonMode>('single');
	public readonly buttonsExtendedListThreshold = input<number>();
	public readonly showNgContent = input<boolean>(false);
	public readonly cardDesign = input<CardDesign>('default');
	public readonly isEditableAvatar = input<boolean>(false);
	public readonly isEditableTitle = input<boolean>(false);
	public readonly buttonsMoreIcon = input<IconType>('more');

	public readonly editAvatarClick = output<void>();
	public readonly titleUpdated = output<string>();

	@HostBinding('style') override style = 'display: block';

	public readonly calculatedTags = computed<readonly TagListItem[] | undefined>(() => {
		const tags = this.tags();

		if (!tags || !tags.length) {
			return undefined;
		}

		if (this.isMobileView()) {
			return tags.slice(0, 4);
		}

		return tags;
	});

	public readonly editableTitle = signal<string>('');

	constructor(private readonly dialogService: DialogService) {
		super();

		effect(() => {
			this.editableTitle.set(this.title());
		});
	}

	handleAvatarClick(): void {
		if (this.isEditableAvatar()) {
			this.editAvatarClick.emit();
		}
	}

	openEditTitle(): void {
		this.dialogService.openFormDialog<TitleForm>({
			size: 'auto',
			title: 'Edit name',
			fields: [
				{
					title: undefined,
					type: 'text',
					propertyName: 'title',
					required: true
				}
			],
			item: {
				title: this.editableTitle()
			},
			save: (item) => {
				this.editableTitle.set(item.title);
				this.titleUpdated.emit(item.title);
			}
		});
	}
}
